import Vue from 'vue'
import Loading from 'buefy/dist/esm/loading'

import '~/assets/styles/loader.scss'

Vue.use(Loading)
